var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
export var headerButtonPadding = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-left: 2rem;\n  padding-right: 2rem;\n"], ["\n  padding-left: 2rem;\n  padding-right: 2rem;\n"])));
var templateObject_1;
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/Authentication/styles.js
// module id = 1358
// module chunks = 118